export const convertToInputValue = (date: Date) => {
  // Date.toISOString converts Date to UTC so we need to
  // offset our timezone manually to prevent potential date wrapping
  const offsetDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  const [dateString] = offsetDate.toISOString().split('T');
  return dateString;
};
